import constant from "../constant";

const initState = {
  chapterName: '',
  chapterId: '',
  catalogs: [
    // {
    //   title: 'Python欢迎你',
    //   label: 'Welcome',
    //   id: '1'
    // },
    // {
    //   title: '代码注释',
    //   label: 'Comment',
    //   id: '2'
    // },
    // {
    //   title: '字符串输出',
    //   label: 'Print',
    //   id: 3
    // }
  ],
  lesson: {
    loading: true,
    //   sections: [
    //     {
    //       content: welcome.content,
    //       version: '0.0.1'
    //     }
    //   ],    // 内容
    //   exercises: [
    //     {
    //       id: '1',
    //       title: '输出你的名字',
    //       desc: welcome.instructionDesc,
    //       type: 'coding', // radio / checkout /coding
    //       solutions: [],
    //       tips: '此处为Welcome小节练习题的题目解析内容',
    //       code: '',
    //       finished: false
    //     },
    //     {
    //       id: '2',
    //       title: '请选择下列选项中描述正确的一项',
    //       desc: '',
    //       type: 'radio',
    //       options: [
    //         {
    //           key: 'A',
    //           content: '选项一'
    //         },
    //         {
    //           key: 'B',
    //           content: '选项二'
    //         },
    //         {
    //           key: 'C',
    //           content: '选项三'
    //         },
    //         {
    //           key: 'D',
    //           content: '选项四'
    //         }
    //       ],
    //       answer: ['C'],
    //       selectedAnswer: [],
    //       tips: '此处为welcome单选题题目解析',
    //       finished: false
    //     }
    //   ],
    //   codeEditor: {
    //     languageId: '71',
    //     code: welcome.editorCode
    //   },
    //   conceptReview: {
    //     content: welcome.conceptReview,
    //     version: '0.0.1'
    //   },
    //   comments: []
  }
};

export default (state = initState, action) => {
  switch (action.type) {
    case constant.chapter.SET_CATALOGS:{
      return {
        ...state,
        catalogs: action.payload
      };
    }
    case constant.chapter.CLEAR_CHAPTER_DATA: {
      return {
        chapterName: action.payload.chapterName,
        chapterId: action.payload.chapterId,
        catalogs: action.payload.catalogs || [],
        lesson: {
          loading: true
        }
      }
    }
    case constant.chapter.SET_LESSON: {
      return {
        ...state,
        lesson: action.payload
      }
    }
    case constant.chapter.LOADING: {
      return {
        ...state,
        lesson: {
          ...state.lesson,
          loading: action.payload
        }
      }
    }
    default:{
      return state;
    }
  }
}
